import React from 'react';
import { t, props } from 'tcomb-react';
import get_bundle from '../domain/get_bundle';
import MarkdownComponent from './MarkdownComponent';

@props({
  locale: t.Obj,
  payments: t.maybe(t.list(t.Str))
})
export default class ProductPayments extends React.Component {

  getPayment(type, description, index) {
    return (<div key={index}><div className={type} ></div><MarkdownComponent>{description}</MarkdownComponent></div>);
  }

  getPayments() {
    const bundle = get_bundle(this.props.locale).payment;
    var payments = this.props.payments
    const clonePayments = [...payments];
    
    return clonePayments.sort().reverse().map((type, index) => this.getPayment(type, bundle[type], index));
  }

  render() {
    if (!this.props.payments) {
      return null;
    }

    return (<div>{this.getPayments()}</div>);
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductPayments.js
 **/